// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__eFzfS","table":"styles_table__fnHIy","headBtn":"styles_headBtn__9EqKD","headBtnActive":"styles_headBtnActive__zdmD1","empty":"styles_empty__Z1tZO"};